/* JIRA ID: BB-45
Node : Adding a solon ID to remove possibilities from the vouchertype selection dropdown for voucher purchasing. */
export const customAmountVoucherTypeOptionRestrict=[
    381
];

export const restrictSalonOnlineVoucherSale=[
    477, 497
]